import authService from "../services/auth.service";
import { toogleErrorMessage } from "./alertMessage";
import {
  DASHBOARD_DETAILS,
  DASHBOARD_DETAILS_LOADER,
  IS_LOGIN,
  NOTIFICATION_DETAILS,
  NOTIFICATION_DETAILS_LOADER,
  PROFILE_DETAIL,
  PROFILE_DETAIL_LOADER,
  VERIFY_TOKEN,
} from "./type";

export const loginAction = (payload) => async (dispatch) => {
  return await authService.login(payload).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: IS_LOGIN, payload: true });
      localStorage.setItem("authToken", resp.data?.token);
      localStorage.setItem("adminId", resp.data?.admin?.id);
    } else {
      console.log(resp?.response?.data?.message);
      dispatch(
        toogleErrorMessage(
          resp?.response?.data?.message || "Something wen't wrong",
        ),
      );
    }
    return resp;
  });
};

export const verifyToken = () => async (dispatch) => {
  return await authService.verifyToken().then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: VERIFY_TOKEN, payload: resp.data });
    } else {
      logoutAction();
    }
    return resp;
  });
};

export const profileAdminDetails = () => async (dispatch) => {
  dispatch({ type: PROFILE_DETAIL_LOADER, payload: true });
  return await authService.adminProfile().then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: PROFILE_DETAIL, payload: resp.data });
    } else {
      dispatch({ type: PROFILE_DETAIL_LOADER, payload: resp.data });
    }
    return resp;
  });
};

export const dashboardApiDetails = () => async (dispatch) => {
  dispatch({ type: DASHBOARD_DETAILS_LOADER, payload: true });
  return await authService.dashboard().then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: DASHBOARD_DETAILS, payload: resp.data });
    } else {
      dispatch({ type: DASHBOARD_DETAILS_LOADER, payload: resp.data });
    }
    return resp;
  });
};

export const notificationApiDetails = (page, limit) => async (dispatch) => {
  dispatch({ type: NOTIFICATION_DETAILS_LOADER, payload: true });
  return await authService.adminNotification(page, limit).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: NOTIFICATION_DETAILS, payload: resp.data });
    } else {
      dispatch({ type: NOTIFICATION_DETAILS_LOADER, payload: resp.data });
    }
    return resp;
  });
};

export const logoutAction = () => {
  localStorage.removeItem("authToken");
};
